module.exports = __webpack_public_path__ + "img/btn_close.4fa4c8fa.svg";